// 群标记列表
import React, { useEffect, useState, useCallback } from "react";
import { Drawer, Button, Spin, Empty, message as toast, Checkbox, Modal } from "antd";
import noticeImg from "@/assets/img/empty/im-empty.png";
import "./index.less";
import open from "./img/open.png";
import close from "./img/close.png";
import { isYearBefore } from "@/utils/date";
import dayjs from "dayjs";
import { delMessageTag, getMessageTagPageList } from "@/api/chat";
import { isGroupAdmin, isGroupOrdinary, isGroupOwner } from "@/utils/chat/group";
import {
  getMessageSendType,
  isCardViewGroupSession,
  isEqualEmployee,
  uidToEmployee
} from "@/utils/chat/message";
import { analysisLog } from "@/utils/logAnalytics";
import Bus from "@/utils/bus";
import { UserCardType } from "@/types/UserCard";
import { Employee } from "@/types/chat";
import { useTranslation } from "react-i18next";
import Text from "@/components/chat/message/Text";
import { connect } from "dvajs";
import ChatState from "@/types/chat/State";
import NetworkCheck, { UseCheckType } from "@/utils/NetworkCheck";
import { getNetCheckUrl } from "@/config/config";
import i18n from "@/i18n";
import Context from "@/components/chat/context";
import { useHistory } from "react-router-dom";
import { findUserRemarkBySession } from "@/utils/chat/session";
import { isChatPage } from "@/utils/chat/index";

function GroupTagList(props: any) {
  const { selectedSession, currentEmployee, setStartMessageId } = props;
  const [delTag, setDelTag] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [tagLists, setTagList] = useState([] as any[]);
  const [visible, setVisible] = useState(false);
  const [count, setCount] = useState(0);
  const [messageIds, setmessageIds] = useState([] as any[]);
  const [updateList, setUpdateList] = useState([] as any[]);
  const { t } = useTranslation("chat");
  const netServer = NetworkCheck.getInstance({
    url: getNetCheckUrl(),
    checkType: UseCheckType.API
  });
  const [loading, setLoading] = useState(true);
  const groupId = selectedSession.sessionId;
  const { groupRosterIdentity } = React.useContext(Context);
  const history = useHistory();
  let pageSize = 20;
  async function againFetch() {
    const [data, error] = await getMessageTagPageList({
      pageNo: 1,
      pageSize: pageSize,
      groupId: groupId
    });
    setTagList(data.list);
  }

  async function getTagList() {
    setLoading(true);
    const onLine = await netServer.checkNet();
    if (!onLine) {
      toast.error(i18n.t("Network Error"));
      return;
    }
    const [data, error] = await getMessageTagPageList({
      pageNo: 1,
      pageSize: pageSize,
      groupId: groupId
    });
    if (data.total > pageSize) {
      pageSize = data.total;
      againFetch();
    }
    setTagList(data.list);
    setLoading(false);
    setCount(0);
    setmessageIds([]);
    setDelTag(false);
  }

  const changePrentVisible = useCallback(
    (params) => {
      setLoading(true);
      setUpdateList([]);
      setVisible(params.visible);
      getTagList();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [groupId]
  );

  useEffect(() => {
    Bus.on("chat:tagList", changePrentVisible);
    return () => {
      Bus.off("chat:tagList", changePrentVisible);
    };
  }, [changePrentVisible]);

  useEffect(() => {
    tagLists.sort(function (a: any, b: any) {
      return b.messageTime - a.messageTime;
    });
    let tempList: any = [];
    // eslint-disable-next-line array-callback-return
    tagLists.map((item: any, index: any) => {
      if (
        index === 0 ||
        dayjs(item?.messageTime).format(`YYYY年MM月DD日`) !==
          dayjs(tagLists[index - 1]?.messageTime).format(`YYYY年MM月DD日`)
      ) {
        tempList.push([item]);
      } else {
        tempList[tempList.length - 1].push(item);
      }
    });
    // eslint-disable-next-line array-callback-return
    tempList.map((item: any) => {
      item.sort(function (a: any, b: any) {
        return a.messageTime - b.messageTime;
      });
    });
    setUpdateList([...tempList]);
  }, [tagLists]);

  function openUserCard(message: any) {
    const { from } = message;
    if (selectedSession?.isNotice) {
      return;
    } else {
      // 如果群成员并且禁止了查看群成员名片
      if (
        !isEqualEmployee(currentEmployee, uidToEmployee(from) as Employee) &&
        isGroupOrdinary(groupRosterIdentity) &&
        !isCardViewGroupSession(selectedSession)
      ) {
        toast.warn(t("can_not_open_user_card_tip"));
        return false;
      }
      analysisLog("Xtbg_Msg_Dialog", "ViewMember");
      Bus.emit("app:toggle-user-card-modal:show", {
        visible: true,
        type: UserCardType.User,
        userId: from?.pin,
        teamId: from.teamId,
        appId: from.app
      });
    }
  }

  function handlePushUrl(mid: any, content: any, timestamp: any) {
    let url = `?sMid=${mid}&sText=${content}&sTimestamp=${timestamp}`;
    if (isChatPage()) {
      if (mid > -1) {
        setStartMessageId({ sMid: mid, sText: content });
      }
    } else {
      history.push(url);
    }
    setVisible(false);
    Bus.emit("chat:tagList", {
      visible: false
    });
  }

  function getSendType(message: any) {
    return getMessageSendType(message, currentEmployee, selectedSession);
  }
  function changeShowList(index: any) {
    const arrowEle = document.getElementsByClassName("list-header-right")[index];
    const tagListEle = document.getElementsByClassName("list-body")[index] as HTMLElement;
    const openList: any = `<span>展开</span><img src="${open}"/>`;
    const closeList: any = `<span>收起</span><img src="${close}"/>`;
    const showTagList = tagListEle.style.display;
    if (showTagList === "flex") {
      arrowEle.innerHTML = openList;
      tagListEle.style.display = "none";
    } else {
      arrowEle.innerHTML = closeList;
      tagListEle.style.display = "flex";
    }
  }
  const msgList = updateList.map((item: any, index: any) => {
    return (
      <div key={index} className="list-container">
        <div
          className="list-header"
          onClick={() => {
            changeShowList(index);
          }}
        >
          <div className="list-header-left">
            <div className="list-header-left-tag" />
            <div className="list-header-left-date">
              {dayjs(item[0].messageTime).format(
                `${isYearBefore(item[0].messageTime) ? "YYYY年M月D日" : "M月D日"}`
              )}
            </div>
          </div>
          <div className="list-header-right">
            <span>收起</span>
            <img src={close} />
          </div>
        </div>
        <div className="list-body" style={{ display: "flex" }}>
          {item.map((item: any, index: any) => {
            const ext = typeof item.ext === "string" ? JSON.parse(item.ext) : {};
            const { from = {} } = ext;
            const { fUserKey = "" } = ext.body;
            const key = fUserKey || `${from.pin}:${from.app}:${from.teamId}`;
            const remark = findUserRemarkBySession(key, selectedSession);
            return (
              <div className="list-body-item" key={index}>
                {delTag && (
                  <Checkbox
                    className="del-tag"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setCount(count + 1);
                        setmessageIds([
                          ...messageIds,
                          {
                            mid: `${item?.messageId}`,
                            uuid: item?.uuid,
                            deviceCode: item?.deviceCode
                          }
                        ]);
                      } else {
                        let newDelList: any = [];
                        setCount(count - 1);
                        newDelList = messageIds.filter(
                          (value) => value?.mid !== `${item?.messageId}`
                        );
                        setmessageIds(newDelList);
                      }
                    }}
                  />
                )}
                <div className="msg-info-time">{dayjs(item.messageTime).format(`HH:mm:ss`)}</div>
                <div className="msg-info-content">
                  <div
                    className="msg-info-name"
                    onClick={() => {
                      if (!delTag) {
                        openUserCard(JSON.parse(item.ext));
                      }
                    }}
                  >
                    <div className="msg-info-name-user">{`${item.realName}${
                      remark ? `（${remark}）` : ""
                    }`}</div>
                    <div className="msg-info-name-unit">{`${
                      isEqualEmployee(
                        currentEmployee,
                        uidToEmployee(JSON.parse(item.ext)?.from) as Employee
                      )
                        ? `@${currentEmployee?.unitName}`
                        : `@${item.deptName}`
                    }`}</div>
                  </div>
                  <div
                    className="msg-content"
                    onClick={() => {
                      if (!delTag) {
                        handlePushUrl(item?.messageId, item?.messageContent, item?.messageTime);
                      }
                    }}
                  >
                    {JSON.parse(item.ext)?.body ? (
                      <Text
                        message={JSON.parse(item.ext).body}
                        sessionType={selectedSession.sessionType}
                        sendType={getSendType(JSON.parse(item.ext).body)}
                        pushUrl={`?sMid=${item?.messageId}&sText=${item?.messageContent}&sTimestamp=${item?.messageTime}`}
                        pushMid={item?.messageId}
                        pushText={item?.messageContent}
                        isPushUrl={!delTag}
                        noSupportPre={true}
                      />
                    ) : (
                      `${item.messageContent}`
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  });

  const handlecancelTag = () => {
    setDelTag(!delTag);
    setCount(0);
    setmessageIds([]);
  };
  const handleOk = async () => {
    setIsModalVisible(true);
  };
  const delOperate = () => {
    if (delTag && !loading) {
      return (
        <div className="operate_footer">
          <div>
            已选<span style={{ color: "#1686ff", marginLeft: 3 }}>{count}</span>
          </div>
          <Button type="primary" onClick={handleOk} disabled={count === 0}>
            确认移除
          </Button>
        </div>
      );
    } else {
      return null;
    }
  };
  return (
    <Drawer
      title={
        <div className="drawer-header">
          <div className="drawer-title">群标记</div>
          {tagLists?.length !== 0 &&
            !loading &&
            (isGroupOwner(groupRosterIdentity) || isGroupAdmin(groupRosterIdentity)) && (
              <Button className="app-region-none" onClick={handlecancelTag}>
                {delTag ? "取消" : "移除"}
              </Button>
            )}
        </div>
      }
      width="500"
      visible={visible}
      className="group_tag_body"
      onClose={() => {
        setVisible(false);
      }}
      closable={false}
      footer={delOperate()}
    >
      <div className="group_tag_main">
        {loading && (
          <div className="loading">
            <Spin spinning={loading} />
          </div>
        )}
        {!loading && tagLists.length !== 0 && msgList}
        {!loading && !tagLists.length && (
          <Empty
            image={noticeImg}
            imageStyle={{
              width: 120,
              height: 120
            }}
            description={<span>暂无群标记内容</span>}
          />
        )}
      </div>
      <Modal
        title="提醒"
        className="removeModal"
        width={400}
        visible={isModalVisible}
        onOk={async (e) => {
          e.stopPropagation();
          setIsModalVisible(false);
          const onLine = await netServer.checkNet();
          if (!onLine) {
            toast.error(i18n.t("Network Error"));
            return;
          }
          const [data, error] = await delMessageTag({
            delMessageTags: messageIds,
            groupId: groupId
          });
          if (error) {
            toast.warn(error);
          } else {
            toast.success(t("removed-successfully"));
          }
          setDelTag(false);
          getTagList();
          setCount(0);
          setmessageIds([]);
        }}
        onCancel={(e) => {
          e.stopPropagation();
          setIsModalVisible(false);
        }}
        okText="确定"
        cancelText="取消"
        maskClosable={true}
        centered
      >
        <p style={{ textAlign: "center" }}>确认移除标记吗？</p>
      </Modal>
    </Drawer>
  );
}

function mapStateToProps({ chat }: any) {
  const { selectedSession, currentEmployee } = chat as ChatState;
  return {
    selectedSession,
    currentEmployee
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    setStartMessageId(data: { sMid: number; sText: string }) {
      dispatch({ type: "chat/setStartMessageId", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupTagList);
